import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('shares', { routeName: 'frontdoorResourceRoute' })
export class Share extends Resource {
    frontends: any;
    agents: string[];
    id: string;
    name: string;
    envId: string;
    authProviderId: string;
    target: string;
    publicName: string
    frontendEndpoint: string;
    shareToken: string;
    frontendSelection: string;
    backendProxyEndpoint: string;
    zId: string;
    token: string;
    envZId: string;
    selected: boolean;
    frontendId: string;
    createdAt: string
    type: string;
    clientPublicKey: string;
    allowedSubjects: string[];
    allowedCommonNamePrefixes: string[];
    organizationalUnit: string;
    ingressPort: string;
    clientCertificateId: string;

}


